export { ArticleShare, type ArticleShareProps } from "./article-share";
export { ArticleShare as default } from "./article-share";
